export default __webpack_public_path__ + "static/wagmidao-9e4ba80c7cf3e75859f9b0b721a89368.jpg";